import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { mUser } from '../../../models/user.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-user-actions-form',
  templateUrl: './user-actions-form.component.html',
  styleUrls: ['./user-actions-form.component.scss']
})
export class UserActionsFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  
  umList : any = [];
  dialogHeader : string = "";

  fhMapping : any = [];
  userId : Number = 0;
  actionType : Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  user = new mUser();

  loadingIndicator = false;
  reorderable = true;

  translations: any;
  
  constructor( @Inject(MAT_DIALOG_DATA)
  public data: { Id : 0, type: 0 },
  public dialog: MatDialog,
  private formBuilder: FormBuilder,
  public appService: AppService,
  private userService: UserService,
  public dialogRef: MatDialogRef<UserActionsFormComponent>){
    this.appService.showLoading();
    this.setPageTranslations();
    this.userId = this.data.Id;
    this.actionType = this.data.type;
    this.setHeader();
  }
  setHeader(){
    this.dialogHeader = this.actionType == 21 ? this.translations["headerRole"] : this.actionType == 22 ? this.translations["headerDistributor"] :  this.translations["headerShipper"];
  }
  ngOnInit() {
    this.select();
  }
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  } 
  select(): void{
    this.userService.selectUserMappings(this.userId, this.actionType).subscribe(
      res => this.selectSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  selectSuccess(res): void{
    this.appService.hideLoading();
    if (res.Status) {
      if(res.Data != 'null' && JSON.parse(res.Data).length > 0)
        this.umList = JSON.parse(res.Data);
      else
        this.apiFaillure(this.translations[res.Message]);
    } else {
      this.apiFaillure(res.Message);
    }
  }
  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue("Error", error);
  }
  close(){
    this.dialogRef.close();
  }
  save(): void{
    this.appService.showLoading();
    this.userService.saveUserMappings(JSON.stringify(this.umList)).subscribe(
      res => this.userMappingSuccess(res),
      error => this.apiFaillure(error)
    );
  }
  userMappingSuccess(res): void{
    this.appService.hideLoading();
    if (res.Status) {
      this.appService.showDialogue("Success",this.translations[res.Message])
      .afterClosed().subscribe(result => {
          if (result) {
            this.close();
          }          
      });    
    } else {
      this.apiFaillure(this.translations[res.Message]);
    }
  }
}





// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/user/user-actions-form/user-actions-form.component.ts